<template>
  <div class="worldMap">
    <!-- <div class="big" @click="showMap">
            <i class="iconfont icon-fangda"></i>
    </div>-->
    <div id="main" style ref="worldMap"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts-gl";
import { mapZHName } from "../../utils/mapName";

export default {
  props: ["mainUrl", "getMapData"],
  data() {
    return {
      mapData: [],
      isShow: false,
    };
  },
  methods: {
    showMap() {
      this.isShow = true;
    },
  },
  watch: {
    mainUrl(n,o) {

      
      console.log('监听mainUrl',n)
      this.$nextTick(() => {
        if(this.mainUrl){
          this.getWorld();
        }
      });
    },


     
  },

  methods: {
    getWorld() {
      this.$http.worldMapInfos(this.mainUrl).then((res) => {
        if ((res.data.code = 200)) {
		  if (typeof res.data.data.htmlinfos == undefined) {
			  this.mapData = [];
		  }
          if (res.data.data.htmlinfos) {
            this.mapData = JSON.parse(res.data.data.htmlinfos);
            // console.log("世界地图", this.mapData);
            this.$emit("getMapData", this.mapData);
            this.worldConfigure();
          } else {
            this.mapData = [];
          }
        }
      });
    },
    worldConfigure(mapData) {
      const worldMap = echarts.init(this.$refs.worldMap); // 绑定页面div盒子
      window.onresize = worldMap.resize; //实现地图自适应
      worldMap.setOption({
        layoutCenter: ["50%", "50%"], //距离左右，上下距离的百分比
        layoutSize: "100%", //map百分比大小
        tooltip: {
          trigger: "item",
          formatter: function (data) {
            // console.log("data", data);
            if (data.data) {
              name =
                data.data.name +
                "<br>" +
                "浏览量：" +
                data.data.value +
                "<br>访客量：" +
                data.data.value2 +
                "<br>访问量：" +
                data.data.value3;
            } else {
              name = data.name;
            }
            return name;
          },
        },
        visualMap: {
          //   type: "piecewise",
          show: false,
          top: "40%",
          // min: 1,
          // max: 100,
          text: ["High", "Low"],
          realtime: false,
          // calculable: true,
          // inRange: {
          //   // color: ["#FF7F00", "yellow", "lightskyblue"]
          //   // color: ["#fc8452","#FFCA4C", "#FFBD88"],
          //   color: [ "#FFBD88","#fc8452","#FFCA4C"],
          // },
          // pieces: [
          //   //    FFBD88
          //   { max: 1000, label: "100以下", color: "#FFCA4C" },
          //   { min: 1000, max: 10000, label: "100-1000", color: "#fc8452" },
          //   { min: 10000, max: 50000, label: "100-1000", color: "#FF2959" },
          //   { min: 50000, color: "#c92a36" },
          // ],
           inRange: {
            color: ["#FFBD88", "#FFCA4C", "#fc8452", "#c92a36"],
          },
    
        },
        // geo3D: {
        //   type: "map3D",
        //   name: "河南",
        //   selectedMode: "single", //地图高亮单选
        //   regionHeight: 5, //地图高度
        //   map: "henan",
        //   viewControl: {
        //     distance: 110, //地图视角 控制初始大小
        //     rotateSensitivity: [1, 1],
        //   },
        // },

        series: [
          {
            nameMap: mapZHName,
            type: "map",
            regionHeight: 5,
            zoom: 1.8,
            mapType: "world",
            roam: true,
            label: {
              normal: {
                show: true,
                color: "#fff",
                fontWeight: "normal",
                position: "inside",
                formatter: function (para) {
                  // console.log("para", para);
                  if (para.data) {
                    // console.log(para.data['0']);
                   if(para.data["0"]<=5){
                     return para.data.name + "\n" + "浏览量:" + para.data.value;
                   }else{
                    return ''
                   }
                  } else {
                    return "";
                  }
                },

                // rich: {
                //   cnNum: {
                //     fontSize: 14,
                //     fontWeight: "bold",
                //     align: "center",
                //     color: "#fff"
                //   },
                //   txtFontsize: {
                //     fontSize: 10,
                //     align: "center",
                //     color: "#02F6F9"
                //   }
                // }
              },
              emphasis: {
                show: true,
                  color:'#ffffff',
                itemStyle:{
                  color:'#ffffff'
                }
              },
            },
            // 地图区域的多边形 图形样式
            itemStyle: {
              areaColor: "#091E64", // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
              borderWidth: 0.5, // 描边线宽 为 0 时无描边
              borderColor: "#024DBA", // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
              borderType: "solid", // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
            },
            // 高亮状态下的多边形和标签样式
            emphasis: {
              label: {
                show: true, // 是否显示标签
                color: "#fff", // 文字的颜色 如果设置为 'auto'，则为视觉映射得到的颜色，如系列色
              },
              itemStyle: {
                color:"#ffffff",
                areaColor: "#9199f4", // 地图区域的颜色
              },
            },

            data: this.mapData,
          },
        ],
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.worldMap {
  position: relative;
  width: 100%;
  height: 400px;
  .big {
    cursor: pointer;
    width: 50px;
    position: absolute;
    z-index: 998;
    i {
      font-size: 30px;
    }
    color: #ffffff;
  }
}
#main {
  width: 100%;
  height: 400px;
}
</style>